/* eslint-disable import/prefer-default-export */
import { api } from '$app/api';

export const createCampaign = (campaign) => api.post('/campaigns', campaign).then((res) => res.data);
